import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_gulf-coast-home/artifacts/nbwe9z7d_IMG_8592.png";

const navItems = [
  { to: "/", label: "Shop" },
  { to: "/blog", label: "Journal" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#F4F1EA]/85 backdrop-blur-xl border-b border-[#E6E1D6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-3 md:py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center group transition-opacity hover:opacity-90">
          <img
            src={LOGO_URL}
            alt="Gulf Coast Home Co."
            width="256"
            height="256"
            loading="eager"
            decoding="async"
            fetchpriority="high"
            className="gc-logo h-16 sm:h-20 md:h-24 lg:h-28 w-auto object-contain select-none"
            draggable={false}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-[#2D3032]" : "text-[#636769] hover:text-[#2D3032]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          {user && (
            <>
              <NavLink
                to="/admin"
                data-testid="nav-admin"
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.18em] transition-colors ${
                    isActive ? "text-[#2D3032]" : "text-[#8EAD9E] hover:text-[#2D3032]"
                  }`
                }
              >
                Studio
              </NavLink>
              <button
                data-testid="logout-btn"
                onClick={() => { logout(); navigate("/"); }}
                className="text-sm uppercase tracking-[0.18em] text-[#EBAA86] hover:text-[#2D3032]"
              >
                Logout
              </button>
            </>
          )}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#2D3032]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E6E1D6] bg-[#F4F1EA]" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navItems.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="text-sm uppercase tracking-[0.18em] text-[#2D3032]"
              >
                {n.label}
              </Link>
            ))}
            {user && (
              <>
                <Link to="/admin" onClick={() => setOpen(false)}
                  data-testid="mobile-nav-admin"
                  className="text-sm uppercase tracking-[0.18em] text-[#8EAD9E]">
                  Studio
                </Link>
                <button onClick={() => { logout(); setOpen(false); navigate("/"); }}
                  data-testid="mobile-logout-btn"
                  className="text-sm uppercase tracking-[0.18em] text-[#EBAA86] text-left">
                  Logout
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
